import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom'
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  registerables,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import zoomPlugin from "chartjs-plugin-zoom";
import {ja} from 'date-fns/locale';


ChartJS.register(...registerables,zoomPlugin);

function ForecastGraph(props) {

  const [time, setTimes] = useState([])
  const [temp, setTemps] = useState([])
  const [prec, setPrecs] = useState([])
  const [snow, setSnows] = useState([])

  useEffect(() => {
    axios.get(`/api/weathernews/forecast/${props.id}`)
      .then(res => {
        setTimes(res.data.dates)
        setTemps(res.data.temps)
        setPrecs(res.data.precipitations)
        setSnows(res.data.snow_depths)
      })
  }, [])

  const graphData = {
    labels: time,
    datasets: [
      {
        label: '気温',
        data: temp,
        borderColor: 'rgba(255, 99, 132, 1)', //線の色
        backgroundColor: 'rgba(255, 99, 132, 0.1)', //塗りつぶしの色
        yAxisID: 'yAxis1'
      },
      {
        label: '降水量(mm/h)',
        data: prec,
        borderColor: 'rgba(21,91,237,1)', //線の色
        backgroundColor: 'rgba(21,91,237,0.1)', //塗りつぶしの色
        yAxisID: 'yAxis1'
      },
      {
        label: '積雪深値(cm)',
        data: snow,
        borderColor: 'rgba(21,237,91,1)', //線の色
        backgroundColor: 'rgba(21,237,91,0.1)', //塗りつぶしの色
        yAxisID: 'yAxis2'
      },
    ],
  };

  function get_Date(i) {
    var date = new Date()
    date.setDate(date.getDate() + i)
    return date
  }

  // ウェザーニュースの短期予報の最も未来の日時をDateオブジェクトで取得する
  // 最も未来の日時は現在の年月日時 + 49時間後となる
  function get_MaxDate() {
    var date = new Date()
    date.setDate(date.getDate() + 2) // 48時間後
    date.setTime(date.getTime() + 60 * 60 * 1000) // さらに1時間追加
  }
  
  // chartjs-plugin-zoomの設定
  const initialZoomOptions = {
    pan: {
      enabled: true,
      mode: "xy",
      overScaleMode: "xy",
    },
    zoom: {
      wheel: {
        enabled: true,
      },
      pinch: {
        enabled: true,
      },
      drag: {
        enabled: false,
      },
      mode: "xy",
      overScaleMode: "xy",
      onZoom: ({ chart }) => {
        if (chart && chart.config && chart.config.options && chart.config.options.scales && chart.config.options.scales.y) {
          const animation = chart.config.options.animation;
          // アニメーションを一時OFFにする
          chart.config.options.animation = false;
          // Y軸の最小値を0にする
          chart.config.options.scales.y.min = 0;
          // 画面を更新する
          chart.update();
          // アニメーションの設定を元に戻す
          chart.config.options.animation = animation;
        }
      },
    },
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      title: {
        display: true,
      },
      zoom: initialZoomOptions,
    },
    interaction: {
      mode: 'index',
      intersect: false
    },
    scales: {
      x: {
        type: 'time',
        min: Math.min(...time),
        max: Math.max(...time),
        adapters: {
          date: {
              locale: ja
          }
        },
      },
      yAxis1: {
        type: 'linear',
        position: 'left',
      },
      yAxis2: {
        type: 'linear',
        position: 'right',
      },
    }
  };

  return (
    <div>
      <Line data={graphData} width="600" height="300" options={options} />
    </div>
  );
}

export default ForecastGraph;
